import { ANPREvent } from 'domain/anpr-event'
import { useCallback, useState } from 'react'
import anprEventApiService from '../api/anpr-event.api'

interface UsePlateHistoryHookReturn {
  events: ANPREvent[]
  isLoading: boolean
  error: string | null
  searched: boolean
  fetchPlateHistory: (clientId: string, licensePlate: string) => Promise<void>
}

export const usePlateHistory = (): UsePlateHistoryHookReturn => {
  const [events, setEvents] = useState<ANPREvent[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [searched, setSearched] = useState(false)

  const fetchPlateHistory = useCallback(
    async (clientId: string, licensePlate: string): Promise<void> => {
      if (!clientId || !licensePlate.trim()) {
        return
      }

      setIsLoading(true)
      setError(null)
      setSearched(true)

      try {
        const response = await anprEventApiService.getPlateHistory(
          clientId,
          licensePlate.trim()
        )
        setEvents(response.responseObject ?? [])
      } catch (err) {
        setError('Falha ao buscar o histórico da placa. Tente novamente.')
        setEvents([])
      } finally {
        setIsLoading(false)
      }
    },
    []
  )

  return { events, isLoading, error, searched, fetchPlateHistory }
}
